// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fail-reason[data-v-5c40f358] {\n  color: #f56c6c;\n  font-size: 12px;\n}\n.no-fail-reason[data-v-5c40f358] {\n  color: #c0c4cc;\n}", ""]);
// Exports
module.exports = exports;
